import classNames from "classnames";
import type { ReactNode } from "react";

export const HorizontalLayout = ({
  children,
  leftComponent,
  rightComponent,
  allowLeftComponentToShrink = false,
  allowRightComponentToShrink = false,
  className,
}: {
  children?: ReactNode;
  leftComponent?: ReactNode;
  rightComponent?: ReactNode | null;
  allowLeftComponentToShrink?: boolean;
  allowRightComponentToShrink?: boolean;
  className?: string;
}) => (
  <div className={classNames(className, "flex-row")}>
    <div className={allowLeftComponentToShrink ? "max-w-[322px]" : "w-[322px]"}>
      {leftComponent}
    </div>
    <div className="flex-fill">{children}</div>
    {rightComponent ? (
      <div
        className={allowRightComponentToShrink ? "max-w-[250px]" : "w-[250px]"}
      >
        {rightComponent}
      </div>
    ) : null}
  </div>
);
